/* eslint-disable max-len */
import {
    Circle,
    Divider, Hide, Show,
    Tab,
    TabList,
    TabPanels,
    Tabs,
} from '@chakra-ui/react';
import { TabDropdown } from '@acp/core-ui';
import { PropertiesStats } from '../properties-stats';
import { useActiveIntegrations } from '../../../../integration';
import { CardLayout } from '../../card-layout';
import { ManagedGraphsTab } from './managed-graphs-tab';
import { NonManagedGraphsTab } from './non-managed-graphs-tab';
import { useGraphsTab } from '../../../hooks/use-graphs-tab';
import { useHasComplianceIssues } from '../../../hooks/use-has-compliance-issues';

export function DashboardIntegratedGraphs(
    { propertyManagerId }: { propertyManagerId?: string | null }
) {
    const { isIntegrated } = useActiveIntegrations();
    const {
        selectedTabIndex,
        setTabByIndex,
    } = useGraphsTab();

    const { hasDiComplianceIssues, hasNonManagedComplianceIssues } = useHasComplianceIssues(propertyManagerId);

    return (
        <>
            { isIntegrated && (<PropertiesStats />) }

            <CardLayout bgColor="white" gap={3} pt={5}>
                <CardLayout.Body>
                    <Tabs
                        isLazy
                        index={selectedTabIndex}
                        w="100%"
                        variant="underline"
                        colorScheme="primary"
                        fontSize="md"
                        onChange={(idx) => setTabByIndex(idx)}
                    >
                        <Show above="md">
                            <TabList w="100%" gap={[0, null, 6]}>
                                <Tab>
                                    Detector Inspector portfolio
                                    {hasDiComplianceIssues && <Circle bg="danger.500" size={2} ml={2} />}
                                </Tab>
                                <Tab>
                                    Other service providers
                                    {hasNonManagedComplianceIssues && <Circle bg="danger.500" size={2} ml={2} />}
                                </Tab>
                            </TabList>
                            <Divider borderColor="muted.100" />
                        </Show>

                        <Hide above="md">
                            <TabDropdown
                                items={[
                                    'DI Portfolio',
                                    'Other service providers',
                                ]}
                                w="full"
                                fontWeight="medium"
                                fontSize="sm"
                            />
                        </Hide>

                        <TabPanels pt={6}>
                            <ManagedGraphsTab propertyManagerId={propertyManagerId} />
                            <NonManagedGraphsTab />
                        </TabPanels>
                    </Tabs>
                </CardLayout.Body>
            </CardLayout>
        </>
    );
}
